import React, { ComponentProps, ReactNode } from 'react';

import PropTypes from 'prop-types';

import ActivityStatus from './ActivityStatus';
import ValueChangeActivityCard from './ValueChangeActivityCard';
import { statusShape, Status } from '../consts';

type StatusChangeActivityCardProps = Omit<
  ComponentProps<typeof ValueChangeActivityCard>,
  'before' | 'after'
> & {
  before?: ReactNode;
  after?: ReactNode;
} & {
  beforeStatus?: Status;
  afterStatus: Status;
};

/**
 * StatusChangeActivityCard component. Describes a single status change activity.
 */
const StatusChangeActivityCard = React.forwardRef<
  HTMLDivElement,
  StatusChangeActivityCardProps
>(({ beforeStatus, afterStatus, ...props }, ref) => {
  return (
    <ValueChangeActivityCard
      ref={ref}
      before={beforeStatus ? <ActivityStatus status={beforeStatus} /> : null}
      after={<ActivityStatus status={afterStatus} />}
      {...props}
    />
  );
});

StatusChangeActivityCard.displayName = 'StatusChangeActivityCard';

StatusChangeActivityCard.propTypes = {
  ...ValueChangeActivityCard.propTypes,
  after: PropTypes.any,
  /** The old status */
  beforeStatus: statusShape,
  /** The new status */
  afterStatus: statusShape.isRequired,
};

export default StatusChangeActivityCard;
